module.exports = __webpack_public_path__ + "static/media/badge-inactive.28548f2b.jpg";